module.exports = __webpack_public_path__ + "static/szenario2_2-31aaa6f7d888d29800b771e100e48e9c.png";